import React from 'react'
import { Flex, Text } from '@chakra-ui/react'

import { Category } from 'appTypes/shop'

type Props = {
  category: Category
  isCategorySelected?: boolean
}

export const CategoryCard: React.FC<Props> = ({ category, isCategorySelected = false }) => {
  return (
    <Flex
      className="gtm-category-block"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%"
      background={isCategorySelected ? 'green.a150' : 'green.a50'}
      borderRadius="xl"
      padding={{ base: '14px 20px', lg: '25px 20px' }}
      cursor="pointer"
    >
      {category.url && (
        <Flex width="100%" height="100%" alignItems="center" justifyContent="center" marginBottom="17px">
          <img loading="eager" src={category.url} alt="Category image" width="120px" height="120px" />
        </Flex>
      )}

      <Text
        className="gtm-category-name"
        fontSize={{ base: 'xs', md: 'lg' }}
        fontWeight={500}
        textAlign="center"
        hyphens="auto"
        color={isCategorySelected ? 'white' : 'black'}
      >
        {category.name}
      </Text>
    </Flex>
  )
}
